module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_41.81e32005.png";